import { Theme } from '@mui/material';
import { makeStyles } from '@mui/styles'

const contentMaxWidth = 1366

const useStyles = makeStyles((theme: Theme) => ({
  loadingContainer: {
    width: '100%',
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
    margin: '10rem 0',
  },

  emptyContainer: {
    width: '100%',
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
    margin: '0.5rem 1rem',

    '& > p': {
      maxWidth: '550px',
      textAlign: 'center',
      font: "400 16px/24px Nunito",

      '& > span': {
        cursor: 'pointer',
        color: theme.palette.primary.main
      }
    },
  },

  image: {
    width: '256px',
    height: '210px',
    objectFit: 'cover'
  }
}));

export { useStyles }
